'use client'

import { useRouter } from 'next/router'
import {
  extractKeywordFromQuery,
  getStoredPartnershipCode,
} from 'utils/b2bDetails'
import { useQueryStringBuilder } from '@app/bookings/hooks/useQueryStringBuilder'

/**
 * Returns a function that appends the current B2B partnershipCode to a URL
 * when present (from query or session storage). Use for links that open in
 * a new tab so the code is preserved on the target site.
 */
export function usePartnershipCodeUrl(): (url: string) => string {
  const router = useRouter()
  const { updateQueryString } = useQueryStringBuilder()
  const partnershipCode =
    extractKeywordFromQuery(router.query) || getStoredPartnershipCode()

  return (url: string) =>
    partnershipCode ? updateQueryString(url, { partnershipCode }) : url
}

export default usePartnershipCodeUrl
